//
//
//
//
//
//
//
//
//

import { i18n } from '../../../ext/i18n';
import ActionsContainer from "./ActionsContainer.vue";
import ListItem from "../custom/ListItem.vue";
import InfoIcon from "./InfoIcon.vue";
import SelectContactInfoExport from "./SelectContactInfoExport.vue";
import {DLP_SOURCE_TYPES} from '../../store/modules/dlp'
import {CONTACT_FIELD_TYPES} from '../../constants'

export default {
    name: "ContactDetailedInfo",
    props: ['params'],
    components: { ActionsContainer, ListItem, InfoIcon, SelectContactInfoExport },
    data: function() {
        let info = i18n.messages[i18n.locale].information
        return {
            exportBtnText: 'Export',
            exportBtnClass: 'fal fa-address-card',
            detailed_props: [
                { prop_name: CONTACT_FIELD_TYPES.SURNAME, description: info.surname },
                { prop_name: CONTACT_FIELD_TYPES.NAME, description: info.name },
                { prop_name: CONTACT_FIELD_TYPES.SECONDNAME, description: info.secondname },
                { prop_name: CONTACT_FIELD_TYPES.ORGANIZATION, description: info.organization },
                { prop_name: CONTACT_FIELD_TYPES.OFFICE, description: info.department },
                { prop_name: CONTACT_FIELD_TYPES.POST, description: info.position },
                { prop_name: CONTACT_FIELD_TYPES.ROOM, description: info.room },
                { prop_name: CONTACT_FIELD_TYPES.LEADER, description: info.head },
                { prop_name: CONTACT_FIELD_TYPES.HELPER, description: info.helper },
                { prop_name: 'worktime', description: info.worktime },
                { prop_name: CONTACT_FIELD_TYPES.BIRTHDAY, description: info.birthday },
                { prop_name: CONTACT_FIELD_TYPES.ICQ, description: info.icq },
                { prop_name: CONTACT_FIELD_TYPES.SITE, description: info.website },
                { prop_name: CONTACT_FIELD_TYPES.WORKADDRESS, description: info.workaddress },
                { prop_name: CONTACT_FIELD_TYPES.HOMEADDRESS, description: info.homeaddress },
                { prop_name: CONTACT_FIELD_TYPES.ADDRESS, description: info.otheraddress },
                { prop_name: CONTACT_FIELD_TYPES.PARTNER, description: info.spouse },
                { prop_name: CONTACT_FIELD_TYPES.CHILDREN, description: info.children },
                { prop_name: CONTACT_FIELD_TYPES.NOTE, description: info.note }
            ]
        };
    },
    computed: {
        cid() { return this.params.cid },
        contact() {
            let obj = app.store.getters['contacts/getMergedContactById'](this.cid);
            let contacts = {};
            obj.fields && obj.fields.forEach(item => {
                if(item.type in contacts && !Array.isArray(contacts[item.type])) {
                    let x = contacts[item.type];
                    contacts[item.type] = [];
                    contacts[item.type].push(x);
                    contacts[item.type].push(item.value);
                } else if(item.type in contacts && Array.isArray(contacts[item.type])) contacts[item.type].push(item.value);
                else contacts[item.type] = item.value;
            });
            return contacts;
        },
        title() {
            let obj = app.store.getters['contacts/getMergedContactById'](this.cid);
            return obj.fio
        },
        details () {
            return this.detailed_props.reduce((prev, cur) => {
                if (cur.prop_name === 'worktime'
                    && this.contact.hasOwnProperty(CONTACT_FIELD_TYPES.WORKSTART)
                    && this.contact.hasOwnProperty(CONTACT_FIELD_TYPES.WORKFINISH)
                ) {
                    prev.push({
                        title: cur.description,
                        text: this.contact[CONTACT_FIELD_TYPES.WORKSTART] + ' - ' + this.contact[CONTACT_FIELD_TYPES.WORKFINISH]
                    });
                } else if (this.contact.hasOwnProperty(cur.prop_name)) {
                    if(Array.isArray(this.contact[cur.prop_name])) {
                        this.contact[cur.prop_name].forEach(item => {
                            prev.push({
                                title: cur.description,
                                text: item
                            });
                        })
                    } else {
                        prev.push({
                            title: cur.description,
                            text: this.contact[cur.prop_name]
                        });
                    }
                }
                return prev;
            }, []);
        },
        details_en() {
            return this.detailed_props.reduce((prev, cur) => {
                if (cur.prop_name === 'worktime'
                    && this.contact.hasOwnProperty(CONTACT_FIELD_TYPES.WORKSTART)
                    && this.contact.hasOwnProperty(CONTACT_FIELD_TYPES.WORKFINISH)
                ) {
                    prev.push({
                        title: cur.prop_name,
                        text: this.contact[CONTACT_FIELD_TYPES.WORKSTART] + ' - ' + this.contact[CONTACT_FIELD_TYPES.WORKFINISH]
                    });
                } else if (this.contact.hasOwnProperty(cur.prop_name)) {
                    if(Array.isArray(this.contact[cur.prop_name])) {
                        this.contact[cur.prop_name].forEach(item => {
                            prev.push({
                                title: cur.prop_name,
                                text: item
                            });
                        })
                    } else {
                        prev.push({
                            title: cur.prop_name,
                            text: this.contact[cur.prop_name]
                        });
                    }
                }
                return prev;
            }, []);
        }
    },
    methods: {
        doContextMenu(event, value) {
            let handlers = []
            event.currentTarget.style.backgroundColor = 'var(--item-bgcolor-hover)'
            handlers.push({item_name: i18n.messages[i18n.locale].copy, handler: () => {
                this.$copyText(value, undefined, {
                    sourceType: DLP_SOURCE_TYPES.CONTACT,
                    sourceData: {
                        cid: this.cid,
                    },
                })
            }});
            this.cmOpen(event, handlers);
        },
        showModalExportWindow() {
            let obj = app.store.getters['contacts/getMergedContactById'](this.cid);
            let fio = `${obj.fio} ${obj[CONTACT_FIELD_TYPES.SECONDNAME]}`;
            fio = fio.replace(/undefined/gi,'')
            let contactArr = this.details_en
                .filter(k=>!k.title.includes('name'));
            contactArr.unshift({title: "fio", text: fio});
            let emails = this.contact[CONTACT_FIELD_TYPES.MAIL];
            if (!!emails && Array.isArray(emails)) {
                emails.forEach(email=>{
                    contactArr.push({title: CONTACT_FIELD_TYPES.MAIL, text: email});
                })
            } else if (!!emails) {
                contactArr.push({title: CONTACT_FIELD_TYPES.MAIL, text: emails});
            }
            let workphones = (Object.entries(this.contact)).filter(([key, value]) => key.includes(CONTACT_FIELD_TYPES.PHONE)).map(([k,v])=> v);
            if (!!workphones && Array.isArray(workphones)) {
                workphones.forEach(workphone=>{
                    contactArr.push({title: CONTACT_FIELD_TYPES.WORKPHONE, text: workphone});
                })
            } else if (!!workphones) {
                contactArr.push({title: CONTACT_FIELD_TYPES.WORKPHONE, text: workphones});
            }
            contactArr = contactArr.map(obj=>({ ...obj, elementClass:'', checked: true }));
            this.modalOpen({
                component: SelectContactInfoExport,
                props: { fieldsArr: contactArr }
            })
        }
    }
}
